import React from 'react';
import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';
import { Tooltip } from '@instinet-analytics/core-lib';

export default function needsRefreshRenderer(params: {
    onClickRefresh: () => void;
}) {
    const defautOnClick = () => {
        return;
    };
    const onClick = params.onClickRefresh ?? defautOnClick;

    return (
        <div className="needs-refresh-cell" onClick={onClick}>
            <ToolbarIcon
                className="refresh-button"
                name="refresh"
                tooltip="Refresh with updated quantity"
            />
            <Tooltip text="Refresh with updated quantity">
                <div>Refresh</div>
            </Tooltip>
        </div>
    );
}
